/**
 * Redirect the current browser page to a URL. Unlike Next.js router navigation,
 * this can safely follow an authentication redirect chain to another origin.
 */
export function redirectToUrl(url: string): void {
    window.location.assign(url);
}
